// Phase 5 of docs/build-plans/pma-stripe-payments.md.
//
// Mirrors apps/pma-server/src/lib/paymentsSettings.js so the
// BillingSettingsPanel can surface inline validation messages without a
// round trip. The server remains authoritative — the same rules are
// re-checked on PATCH /api/settings/billing.

// Stripe applies the platform-level prefix `INV` automatically on
// the Connect platform account, so the per-practice value should NOT
// repeat it (would render `INV* INV PAYMENT`). Combined cardholder-
// facing format is `INV* {suffix}` and Stripe caps the combined at
// 22 chars — `INV* ` consumes 5, leaving 17 for the suffix.
export const DEFAULT_STATEMENT_DESCRIPTOR = 'PAYMENT';
export const MAX_STATEMENT_DESCRIPTOR_LEN = 17;

export const BANNED_DESCRIPTOR_TOKENS = [
    'THERAPY', 'ABA', 'AUTISM', 'BEHAVIOR', 'CLINICAL', 'MEDICAL',
] as const;

const ASCII_PRINTABLE_RE = /^[\x20-\x7E]+$/;

/** Returns null when acceptable, or the human-readable error message. */
export function validateStatementDescriptor(value: string): string | null {
    if (typeof value !== 'string') return 'Statement descriptor must be a string.';
    const trimmed = value.trim();
    if (!trimmed) return 'Statement descriptor cannot be empty.';
    if (trimmed.length > MAX_STATEMENT_DESCRIPTOR_LEN) {
        return `Statement descriptor must be ${MAX_STATEMENT_DESCRIPTOR_LEN} characters or fewer.`;
    }
    if (!ASCII_PRINTABLE_RE.test(trimmed)) {
        return 'Statement descriptor must be plain ASCII (no accents or emoji).';
    }
    if (/[<>\\'"*]/.test(trimmed)) {
        return 'Statement descriptor cannot contain < > \\ \' " or *.';
    }
    const upper = trimmed.toUpperCase();
    for (const banned of BANNED_DESCRIPTOR_TOKENS) {
        const re = new RegExp(`(^|[^A-Z])${banned}([^A-Z]|$)`);
        if (re.test(upper)) {
            return `Statement descriptor cannot contain "${banned}" — parents' family members see this on the card statement.`;
        }
    }
    return null;
}
